export const Colors = {
  primaryColor: '#9298ac',
  secondaryColor: '#5cb3db',
  black: '#000',
  white: '#fff',
  gary: '#e4e9f2',
};
